import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const DocumentAdd = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
          fill="#2D425B"
          fillOpacity="0.05"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 12C2.5 6.7533 6.7533 2.5 12 2.5C17.2467 2.5 21.5 6.7533 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.7533 21.5 2.5 17.2467 2.5 12ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM12 7.95C12.3038 7.95 12.55 8.19624 12.55 8.5V11.45H15.5C15.8038 11.45 16.05 11.6962 16.05 12C16.05 12.3038 15.8038 12.55 15.5 12.55H12.55V15.5C12.55 15.8038 12.3038 16.05 12 16.05C11.6963 16.05 11.45 15.8038 11.45 15.5V12.55H8.50002C8.19626 12.55 7.95002 12.3038 7.95002 12C7.95002 11.6962 8.19626 11.45 8.50002 11.45H11.45V8.5C11.45 8.19624 11.6963 7.95 12 7.95Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default DocumentAdd
